/* ========================== */  
/* ========= import ========= */  
/* ========================== */ 

/* ====== React ====== */
// import React from "react"
/* ====== CSS ====== */
import styled from 'styled-components';
/* ====== Component Js/Jsx ====== */
import { assets } from "03CommonApiParts/Configuration";
import { InputErrorMessage } from '02CommonUiParts/TableParts/InputErrorMessage';
/* ========================== */  
/* ========= Styles ========= */  
/* ========================== */  

/* ====== Styled Components ====== */
const Slabel = styled.label`//セレクトラベル
    position: absolute;
    left: 0px;
    margin: 3px 0;
    color: ${assets().color.gray};
    pointer-events: none;
    background:white;
    padding:0 3px;
    transform: scale(0.8, 0.8);
`;
const SselectRange = styled.select`//セレクト
    padding: 0px 5px;
    margin: 2px 0;
    width:${props=>props.width};
    border-radius: 3px;
    border: ${ props => props.readOnly ? 'none' : 'solid 1px #C0C0C0'};
    appearance: ${props => props.readOnly ? 'none': '' };
    &:focus{
        outline: solid 1.5px #007BC3;
    };
    &:disabled{
        color:black;
        opacity:1;
        background-color:${props => props.disabled ? 'transparent': assets().color.disabled  };
    };
    &:disabled+${Slabel}{
        background: linear-gradient(180deg, white 0%, white 50%, ${assets().color.disabled} 50%, ${assets().color.disabled} 100%);
    }
`;
const SoptionRange = styled.option`//選択肢（オプション）
`;

const SinputBox = styled.div`//セレクト枠
    position: relative;
    border-radius: 3px;
`;

/*<SelectBox
id="status"
label={item.name ? item.name : item.range.name}
payload={payload} //react-hook-form
register={register(`${payload}.${item.id}`,//react-hook-form
{
    required:item.required?CFArrayFount(inputCheckMaster.list,'value','required').label:'',
})} 
errorMessage={error[payload]?.[item.id]?.message}//react-hook-form
range={item.range.list} //選択肢
disabled={item.disabled}
width={item.width}
/>*/
/* ========================== */  
/* ========== Main ========== */  
/* ========================== */
export const SelectBox = (props) => {
    /* ========================== */  
    /* ========== variables ========== */  
    /* ========================== */  
    const { boxStyle, value, range, register, errorMessage, label, disabled, width } = props;
    /* ========================== */  
    /* ====== Start Render ====== */  
    /* ========================== */
    return (
        !disabled ? 
        <>
            <SinputBox style={boxStyle} width={width}>
                <SselectRange
                    id='select-year-label'
                    value={value}
                    style={{fontSize:assets().size.baseText,height:assets().size.inputHeight}}
                    width={width}
                    {...register} //react hook form用
                    className='inputText'
                >
                    <option value="">--選択--</option>
                    {range.map((year) => (
                        <SoptionRange
                            key={year.value}
                            value={year.value}
                        >
                            {year.label}
                        </SoptionRange>
                    ))}
                </SselectRange>
                <Slabel label={label} className='inputlabelText' style={{fontSize:assets().size.inputlabelText,top:assets().size.inputlabelTop}}>{label}</Slabel>
            </SinputBox>
            {errorMessage ? <InputErrorMessage errorMessage={errorMessage}/> : ''}
        </>
        :<></>
    );
};
